import dayjs from "dayjs"; 
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Popover from "@mui/material/Popover";
import IRMenu from "./IRMenu";
import KeyManagerialPersonsModal from "./KeyManagerialPersonsModal";
import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";


import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";


const KeyManagerialPersons = () => {

    const { irId } = useParams();
    const history = useHistory();

    const keyManagerialPersonsData = [
        {
            _id: "1",
            name: "Ravi Kumar",
            designation: "Managing Director",
            dateOfAppointment: "15-04-2018",
            dateOfResignation: "",
        },
        {
            _id: "2",
            name: "Sneha Patel",
            designation: "Chief Financial Officer",
            dateOfAppointment: "07-10-2019",
            dateOfResignation: "",
        },
        {
            _id: "3",
            name: "Arjun Mehta",
            designation: "Independent Director",
            dateOfAppointment: "01-05-2020",
            dateOfResignation: "30-09-2023",
        },
        {
            _id: "4",
            name: "Neha Sharma",
            designation: "Company Secretary",
            dateOfAppointment: "03-12-2021",
            dateOfResignation: "",
        },
        {
            _id: "5",
            name: "Vikram Singh",
            designation: "Non-Executive Director",
            dateOfAppointment: "20-11-2022",
            dateOfResignation: "",
        },
    ];


    const [anchorEl, setAnchorEl] = useState(null);
    const [openPopoverId, setOpenPopoverId] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false)
    const [modalType, setModalType] = useState(null);


    const open = Boolean(anchorEl);

    const handleAdd = () => {
        setSelectedData(null);
        setModalType("add");
        setModalOpen(true);
    };

    const handleMenuClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setOpenPopoverId(id);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpenPopoverId(null);
    };

    const handleEdit = (item) => {
        setSelectedData(item);
        setModalType("edit");
        setModalOpen(true);
        handleClose();
    };

    const handleDelete = (id) => {
        console.log("Delete clicked for:", id);
        handleClose();
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedData(null);
        setModalType(null);
    };

    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu
                    activeTab={"Key Managerial Persons"}
                    registerID={irId}
                />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
                    <div className={investmentRegisterCss.iRHeader}>
                        {/* <Button
                            btnColor={buttoncss.primary}
                            icon={<PlusIcon />}
                            label="Create Investment"
                            onClick={() => { history.push(`/create-investment/${irId}`) }}
                        /> */}
                    </div>
                    <div className={investmentRegisterCss.tableLayout}>
                        <div className={investmentRegisterCss.tableConatiner}>
                            <div className={investmentRegisterCss.tableTitle}>
                                <span>Key Managerial Persons</span>
                                <span>
                                    <Button
                                        btnColor={buttoncss.greyBg}
                                        icon={<PlusPrimaryIcon />}
                                        class_={investmentRegisterCss.addBtnRow}
                                        onClick={handleAdd}
                                    />
                                </span>
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign:"left" }}>Name</th>
                                        <th style={{ textAlign:"left" }}>Designation</th>
                                        <th>Date of appointment</th>
                                        <th>Date of resignation</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {keyManagerialPersonsData.map((item)=> (
                                        <tr key={item._id}>
                                            <td style={{ textAlign:"left" }}>{item.name}</td>
                                            <td style={{ textAlign:"left" }}>{item.designation}</td>
                                            <td>{item.dateOfAppointment? dayjs(item.dateOfAppointment, "DD-MM-YYYY").format("DD-MMM-YYYY"): "-"}</td>
                                            <td>{item.dateOfResignation? dayjs(item.dateOfResignation, "DD-MM-YYYY").format("DD-MMM-YYYY"): "-"}</td>
                                            <td>
                                                <MenuDotsIcon
                                                    style={{ cursor: "pointer", marginRight: 20 }}
                                                    onClick={(e) => handleMenuClick(e, item._id)}
                                                />
                                                <Popover
                                                    open={open && openPopoverId === item._id}
                                                    anchorEl={anchorEl}
                                                    onClose={handleClose}
                                                    anchorOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    }}

                                                >
                                                    <div className={investmentRegisterCss.irOptions}>
                                                        <span
                                                            style={{ borderBottom: "1px solid #EAEEED" }}
                                                            onClick={() => handleEdit(item)}
                                                        >
                                                            Edit
                                                        </span>
                                                        <span onClick={() => handleDelete(item._id)}>Delete</span>
                                                    </div>

                                                </Popover>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>

                </motion.div>
            </div>
            {modalOpen && (
                <KeyManagerialPersonsModal
                    handleClose={handleModalClose}
                    data={selectedData}
                    type={modalType}
                />
            )}
        </>
    )
}

export default KeyManagerialPersons;